import React from "react";
import InstagramIcon from "@material-ui/icons/Instagram";
import TwitterIcon from "@material-ui/icons/Twitter";
import FacebookIcon from "@material-ui/icons/Facebook";
import LinkedInIcon from "@material-ui/icons/LinkedIn";
import "../styles/Footer.css";

function Footer() {
  return (
    <div className="footer">
      <div className="socialMedia">
        <a href="https://www.instagram.com/getkarigar9125691256/" target="_blank" rel="noopener noreferrer">
          <InstagramIcon />
        </a>
        <a href="https://x.com/getkarigar" target="_blank" rel="noopener noreferrer">
          <TwitterIcon />
        </a>
        <a href="https://www.facebook.com/GetKarigar9125691256/" target="_blank" rel="noopener noreferrer">
          <FacebookIcon />
        </a>
        <a href="https://www.linkedin.com/company/get-karigar/about/" target="_blank" rel="noopener noreferrer">
          <LinkedInIcon />
        </a>
      </div>
      <p> &copy; COPYRIGHT 2025 GETCON MEDIA PVT. LTD. ALL RIGHTS RESERVED</p>
    </div>
  );
}

export default Footer;
